<template>
  <div
    v-if="model && model.vars && model.vars.label && !model.vars.hide"
    :class="'subTitleType' + (model.vars?.attr?.class ? ' ' + model.vars?.attr?.class : '')"
    v-html="model.vars.label"
  ></div>
</template>

<script>
export default {
  name: "SubTitleTypeComponent",
  props: {
    model: {
      type: Object,
      required: true,
    },
  },
  methods: {
    isMobile() {
      return window.innerWidth < 992;
    },
  },
};
</script>

<style lang="scss" scoped>
p {
  white-space: pre-wrap;
}
</style>
